import { Icon, Text, HStack } from '@genial/components';
import { ColorTypes, Spacing, Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import { Pressable } from 'native-base';
import React from 'react';
import { Animated } from 'react-native';

export declare namespace ActionButtonTypes {
  export interface Props {
    actionPressable: () => void;
    blockListRetryLoading: boolean;
    isSendDisabled: boolean;
    canRetry: boolean;
    actionIconColor: string;
    actionTextColor: string;
    rotation: Animated.Value;
  }
}

export const ActionButton: React.FC<ActionButtonTypes.Props> = ({
  actionPressable,
  blockListRetryLoading,
  isSendDisabled,
  canRetry,
  actionIconColor,
  actionTextColor,
  rotation,
}) => {
  return (
    <Pressable isDisabled={blockListRetryLoading || isSendDisabled} onPress={actionPressable}>
      <HStack alignItems="center">
        <Text
          numberOfLines={1}
          ellipsizeMode="tail"
          fontWeight={Typography['fontweight.semibold']}
          fontSize={Utils.Responsive.All({
            phone: Typography['fontsize.xs'],
            tablet: Typography['fontsize.xs'],
            desktop: Typography['fontsize.md'],
          })}
          paddingRight={Spacing['inline.quarck']}
          flex={1}
          color={actionTextColor as ColorTypes.Option}
          textAlign="start">
          {canRetry ? 'REENVIAR' : 'DESBLOQUEAR'}
        </Text>
        <Animated.View
          {...(canRetry && {
            style: {
              transform: [
                {
                  rotate: rotation.interpolate({
                    inputRange: [0, 1],
                    outputRange: ['0deg', '360deg'],
                  }),
                },
              ],
            },
          })}>
          <Icon
            name={canRetry ? 'Refresh' : 'Unlock'}
            color={actionIconColor}
            testId="action-button"
            size="xs"
          />
        </Animated.View>
      </HStack>
    </Pressable>
  );
};
